<template>
  <div :disabled="disabled"  :data-track="track">
    <div :class="classes" :style="{backgroundColor: bgcolor, color: color}" @click="bindOriginSubmit">
      <span>¥{{ price }}</span>
      立即问医生
      <p class="new-free" v-if="priceInfo && priceInfo.freeCount !== '0'">本次免费 剩余{{priceInfo.freeCount}}次</p>
    </div>
    <div class="new-vip-btn" @click="bindVipSubmit">
      <span>{{vipOpenText}}{{ otherPrice }}</span>
    </div>
  </div>
</template>

<script>
  import {isColor} from '../assets/utils';

  export default {
    name: 'newButton',
    props: {
      disabled: Boolean,
      type: {
        validator(value) {
          return ['primary', 'danger', 'warning', 'hollow', 'disabled', 'normal'].indexOf(value) > -1;
        },
        default: 'normal'
      },
      size: {
        validator(value) {
          return ['small', 'large'].indexOf(value) > -1;
        }
      },
      bgcolor: {
        validator(value) {
          let bgFlag = true;
          if (!value) {
            bgFlag = true;
          } else {
            bgFlag = isColor(value);
          }
          return bgFlag;
        }
      },
      color: {
        validator(value) {
          let cologFlag = true;
          if (!value) {
            cologFlag = true;
          } else {
            cologFlag = isColor(value);
          }
          return cologFlag;
        }
      },
      track: '',
      price: '',
      vipOpenText: '',
      otherPrice: '',
      priceInfo: null
    },
    computed: {
      classes() {
        const s = this.size === 'large' ? 'new-btn-block' : 'new-btn';
        let b = `new-btn-${this.type}`;
        let c = '';
        if (this.disabled) {
          b = 'new-btn-disabled';
        }

        if (this.bgcolor) {
          b = '';
        }
        if (this.priceInfo && this.priceInfo.freeCount !== '0') {
          c = 'has-free';
        }
        return `${s}  ${b} ${c}`;
      }
    },
    methods: {
      bindOriginSubmit() {
        this.$emit('bindOriginSubmit', 0);
      },
      bindVipSubmit() {
        this.$emit('bindVipSubmit', 1);
      }
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";


  .new-btn-variant() {
    text-align: center;
    position: relative;
    border: none;
    pointer-events: auto;
  }

  .new-btn {
    .new-btn-variant();
    height: 30px;
    font-size: 26px;
    display: inline-block;
    padding: 0;
    box-sizing: content-box;
  }
  .new-btn-block {
    position: relative;
    .new-btn-variant();
    width:50%;
    display: block;
    font-size: 34px;
    height: 100px;
    line-height: 100px;
    float: left;
    .new-free {
      text-align: center;
      font-size: 22px;
      position: absolute;
      bottom: 12px;
      width: 100%;
      height: 24px;
      line-height: 24px;
      text-align: center;
    }
    &.has-free{
      line-height: 80px;
    }
  }

  .new-btn-primary, .new-btn-normal {
    background:linear-gradient(310deg,rgba(109,255,227,1) 0%,rgba(0,177,188,1) 100%);
    color: #fff;
  }

  .new-btn-danger {
    background-color: @color-main;
    color: #fff;
  }

  .new-btn-warning {
    background-color: @color-main;
    color: #fff;
  }

  .new-btn-disabled {
    background-color: @color-gray-light;
    color: #fff;
    pointer-events: none;
  }
  .new-vip-btn{
    width: 50%;
    float: left;
    background:rgba(102,102,102,1);
    text-align: center;
    height: 100px;
    line-height: 100px;
    font-size:24px;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(219,172,89,1);
    span{
      font-size: 28px;
      padding-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// NewBtn.vue?010ad97b